// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EdgeConnectSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="EdgeConnectSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M15.316 1.5H8.643a.18.18 0 0 0-.184.183v5.115A1.763 1.763 0 0 1 6.7 8.565H5.6a1.1 1.1 0 0 0-1.1 1.104v1.765a1.1 1.1 0 0 0 1.1 1.105h1.1a1.763 1.763 0 0 1 1.76 1.766v1.251a2.94 2.94 0 0 0 2.934 2.944h.072a2.94 2.94 0 0 0 2.935-2.944v-.073a2.94 2.94 0 0 0-2.935-2.944H10.44a1.764 1.764 0 0 1-1.76-1.767v-.441a1.764 1.764 0 0 1 1.76-1.767h4.876c.1 0 .184-.085.184-.183V1.683A.184.184 0 0 0 15.316 1.5M7.397 11.505a1.33 1.33 0 0 1-.947.394 1.343 1.343 0 0 1-1.341-1.346 1.345 1.345 0 0 1 1.34-1.345 1.34 1.34 0 0 1 1.34 1.346 1.34 1.34 0 0 1-.392.951" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EdgeConnectSignetIcon = /* @__PURE__ */ Object.assign(
  EdgeConnectSignetIconComponent,
  { displayName: 'EdgeConnectSignetIcon' },
);
